










// Copyright © 2021 Move Closer

import { defineComponent, PropType } from '@vue/composition-api'

import { AbstractBreadcrumbsItem, abstractBreadcrumbsProps } from '../../../../../abstract'

import { DashmixIcon } from '../../atoms/Icon'

import { DashmixDropdown } from '../Dropdown'
import { DashmixBreadcrumbsItem } from './_partials/BreadcrumbsItem.vue'

/**
 * @author Jan Dobrowolski <jan.dobrowolski@movecloser.pl>
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const DashmixBreadcrumbs = defineComponent({
  name: 'DashmixBreadcrumbs',
  components: { DashmixBreadcrumbsItem, DashmixIcon, DashmixDropdown },
  props: {
    ...abstractBreadcrumbsProps,
    root: {
      type: Object as PropType<AbstractBreadcrumbsItem>,
      required: true
    }
  }
})

export default DashmixBreadcrumbs
